import AssetPickerAssetListView from 'backbone/platform/views/assets/asset_picker_asset_list_view.js'
import Template from 'backbone/platform/templates/assets/assets_collection_list.js.hamlc'

export default class AssetsCollectionListView
  template: Template

  assetViewClass: AssetPickerAssetListView

  viewStyle: "list-view"

  events:
    "click .headers .header-text" : "sortByColumn"

  sortByColumn: (e) ->
    @_renderSortInfo($(e.currentTarget).parent("th"))
    @collection.sortByColumn
      column: $(e.currentTarget).parent("th").data("sortBy")
    @_renderCollection()

  _renderSortInfo: (elem) ->
    if elem.hasClass("active")
      @_toggleArrow(elem)
    else
      @_switchActiveHeaderTo(elem)

  _toggleArrow: (elem) ->
    arrow = elem.find(".icon")
    if arrow.hasClass("icon-angle-up")
      arrow.removeClass("icon-angle-up")
      arrow.addClass("icon-angle-down")
    else
      arrow.removeClass("icon-angle-down")
      arrow.addClass("icon-angle-up")

  _switchActiveHeaderTo: (elem) ->
    activeHeader = @$("th.active")
    activeHeader.removeClass("active")
    activeHeader.find(".icon").removeClass("icon-angle-up")
    activeHeader.find(".icon").removeClass("icon-angle-down")
    elem.addClass("active")
    elem.find(".icon").addClass("icon-angle-up")

  _renderCollection: ->
    @$("tbody").empty()
    @collection.each (asset) =>
      assetView = new @assetViewClass
        asset: asset
        clickCallback: @options.clickCallback
      @subviews.push(assetView)
      @$("tbody").append(assetView.render().$el)



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/views/assets/assets_collection_list_view.js.coffee